import { combineReducers } from 'redux';
import { fromJS } from 'immutable';
import getApiReducer from '../common/utils/getApiReducer';

import { UPDATE_MOVEMENT_SPECIALIST_PROFILE, FETCH_MOVEMENT_SPECIALIST_PROFILES } from './actions';

const profilesReducer = getApiReducer(FETCH_MOVEMENT_SPECIALIST_PROFILES);
const profiles = (state, action) => {
  state = profilesReducer(state, action);

  if (action.type === `${UPDATE_MOVEMENT_SPECIALIST_PROFILE}_SUCCESS`) {
    const data = state.getIn(['data', 'results']);
    const index = data.findIndex(item => item.get('id') === action.json.id);

    state = state.setIn(['data', 'results'], data.set(index, fromJS(action.json)));
  }

  return state;
};

export default combineReducers({
  profiles,
});



// WEBPACK FOOTER //
// ./src/movement-specialists/reducers.js